<ng-template #modal let-modal class="modal-dialog-centered">
    <div class="modal-header">
        <h4 class="modal-title text-center w-100" id="modalLabel">{{ modalTitle | translate }}</h4>
        <button type="button" class="btn-close" tabindex="-1" aria-label="Close" (click)="closeModal()">
        </button>
    </div>
    <div class=" modal-body p-1">
        <div *ngIf="loading" class="row" style="height: 30px">
            <app-ui-preloader id="spinner" [display]="loading" [size]="'20px'"></app-ui-preloader>
        </div>

        <form *ngIf="!loading" [formGroup]="eventForm" class="p-2 mt-n2 form">
            <div class="row">
                <div class="col-md-12">
                    <div class="mb-1">

                        <label class="form-label">{{ 'SETTINGS.EVENT.TYPE' | translate }}</label>
                        <ngx-select formControlName="Type" appendTo="body" [items]="types" placeholder=""
                            [ngClass]="{'is-invalid':submitted && formEvent.Type.invalid}" required
                            [disabled]="disableTypeSelect">
                        </ngx-select>
                        <div *ngIf="submitted && formEvent.Type.invalid" class="invalid-feedback">
                            <div *ngIf="formEvent.Type.errors?.required" i18n>
                                {{ 'SETTINGS.EVENT.TYPEREQUIRED' | translate }}
                            </div>
                        </div>
                    </div>
                    <div class="mb-1">
                        <label class="form-label">{{ 'SETTINGS.EVENT.COLOR' | translate }}</label>
                        <input class="form-control" type="color" formControlName="Color">
                    </div>
                </div>
            </div>
        </form>

        <!-- <div *ngIf="!loading" id="tab" class="col-md-12">
            <ul ngbNav #tab="ngbNav" [(activeId)]="tabsEvent" class="nav-tabs nav-bordered">
                <ng-container *ngFor="let language of languages; let i = index">
                    <li [ngbNavItem]="i+1">
                        <a ngbNavLink>
                            {{language.description}}
                        </a>

                        <ng-template ngbNavContent>
                            <ng-container *ngTemplateOutlet="language.locale=='pt'?Tab1:Tab2">
                            </ng-container>
                        </ng-template>
                    </li>
                </ng-container>

            </ul>

            <div [ngbNavOutlet]="tab"></div>
        </div> -->
        <ng-container *ngTemplateOutlet="Tab2">
        </ng-container>

        <!-- <ng-template #Tab1>
            <form [formGroup]="eventForm" class="p-2 mt-n2 form">
                <div class="row">
                    <div class="col-md-12">
                        <div class="mb-2">

                            <label for="field-3" class="form-label">{{ 'SETTINGS.EVENT.DESCRIPTION' | translate
                                }}</label>
                            <input type="text" class="form-control" id="field-3" formControlName="TypePT"
                                [ngClass]="{'is-invalid':submitted && formEvent.TypePT.invalid}" required>

                            <div *ngIf="submitted && formEvent.TypePT.invalid" class="invalid-feedback">
                                <div *ngIf="formEvent.TypePT.errors?.required" i18n>
                                    {{ 'SETTINGS.EVENT.DESCRIPTIONREQUIRED' | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </ng-template> -->

        <ng-template #Tab2>
            <form [formGroup]="eventForm" class="p-2 mt-n2 form">
                <div class="row">
                    <div class="col-md-12">
                        <div class="mb-2">
                            <label class="form-label">{{ 'SETTINGS.EVENT.DESCRIPTION' | translate }}</label>
                            <input type="text" class="form-control" formControlName="TypeEN"
                                [ngClass]="{'is-invalid':submitted && formEvent.TypeEN.invalid}" required>

                            <div *ngIf="submitted && formEvent.TypeEN.invalid" class="invalid-feedback">
                                <div *ngIf="formEvent.TypeEN.errors?.required" i18n>
                                    {{ 'SETTINGS.EVENT.DESCRIPTIONREQUIRED' | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </ng-template>

    </div>
    <div class="mt-1 mb-2 d-flex justify-content-center">
        <button *ngIf="eventForm.value.Id !=0 && eventForm.value.Id !=null"
            class="btn btn-primary waves-effect waves-light btnSaveBottom  mt-1 btnSaveMinW2" [disabled]="loading" (click)="save()" >
            {{'SETTINGS.EVENT.EDITEVENT'|translate}}
        </button>
        <button *ngIf="eventForm.value.Id ==0 || eventForm.value.Id ==null"
            class="btn btn-primary waves-effect waves-light btnSaveBottom  mt-1 btnSaveMinW2" [disabled]="loading" (click)="save()"  >
            {{'SETTINGS.EVENT.ADDEVENT'|translate}}
        </button>
    </div>
</ng-template>